import { shallow } from "zustand/shallow";

import { useGenomeViewerStore } from "../../store/store.ts";
import { useGroupHeight } from "./hooks/use-group-height.ts";
import { REGION_INDICATOR_OVERLAP } from "./settings.ts";
import { TrackGroupItem } from "./TrackGroupItem.tsx";

interface TrackGroupOverviewProps {
  scale: number;
  panelWidth: number;
}

export const TrackGroupOverview = ({ scale, panelWidth }: TrackGroupOverviewProps) => {
  const groupHeight = useGroupHeight();
  const groupIds = useGenomeViewerStore(
    (state) => [...state.trackGroups.entries()].filter(([, group]) => group.graphics.isVisible).map(([key]) => key),
    shallow,
  );

  return (
    <g transform={`translate(0, ${REGION_INDICATOR_OVERLAP / 2})`}>
      {groupIds.map((groupId: string, index: number) => {
        return (
          <TrackGroupItem
            key={`contig-overview-${groupId}`}
            idx={index}
            groupId={groupId}
            groupHeight={groupHeight}
            scale={scale}
            panelWidth={panelWidth}
          />
        );
      })}
    </g>
  );
};
